import { handleSpringDataRequest } from "../../../../api";

export const handleCheckIn = (bookingId) => {
  handleSpringDataRequest(
    `core/api/v1/non-rental-booking/checkin?bookingId=${bookingId}`
  )
    .then(() => {})
    .catch(() => {});
};

export const handleCheckOut = (bookingId) => {
  handleSpringDataRequest(
    `core/api/v1/non-rental-booking/checkout?bookingId=${bookingId}`
  )
    .then(() => {})
    .catch(() => {});
};
